import type { User } from 'oidc-client-ts';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter, Route, Routes } from 'react-router';
import { config } from './config';
import { main } from './configuration';
import { handleLoginRedirect } from './configuration/login/redirect';
import { store } from './configuration/setup/store';
import { App } from './features/app/App';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import { InvalidLogin } from './features/app/InvalidLogin';
import { NoMatch } from './features/app/NoMatch';

const renderApplication = ({ user, logout }: { user: User | null; logout: () => void }) => {
    const container = document.getElementById('root');
    // biome-ignore lint/style/noNonNullAssertion: suppressed out of convenience for migration to biomejs
    const root = createRoot(container!);

    let showApp = true;
    try {
        showApp = user?.profile.sub.startsWith('azure-my-rio-de:') ?? false;
    } catch (e) {
        console.error(e);
    }

    // Note that we need to use the base "Router" with a "hash" history
    // because the "HashRouter" doesn't allow handing in a history
    // from the outside. So this is effectively a "HashRouter" despite
    // that not being obvious here
    if (showApp) {
        root.render(
            <ErrorBoundary>
                <Provider store={store}>
                    <HashRouter>
                        <Routes>
                            <Route path={'*'} element={<App logout={logout} />} />
                            <Route path={'/error'} element={<NoMatch />} />
                        </Routes>
                    </HashRouter>
                </Provider>
            </ErrorBoundary>
        );
    } else {
        root.render(<InvalidLogin idToken={user?.id_token} />);
    }
};

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else {
    void main(renderApplication);
}
